import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/react';
import ChevronIcon from '@atlaskit/icon/glyph/chevron-down';
import { PrimaryButton } from '../PrimaryButton';
var chevronIconStyles = css({
  marginRight: '-8px',
  marginLeft: '-8px',
  opacity: 0.51
});

/**
 * __Primary dropdown button__
 *
 * A primary dropdown button allows you to add dropdown menus to the navigation.
 * Should be passed into `AtlassianNavigation`'s `primaryItems` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#button)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */
export var PrimaryDropdownButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(PrimaryButton, _extends({
    iconAfter: jsx("span", {
      css: chevronIconStyles
    }, jsx(ChevronIcon, {
      label: ""
    })),
    ref: ref
  }, props));
});
export default PrimaryDropdownButton;